class PermissionSlug {

  roles_and_permissions = {
    roles_and_permissions: "roles_and_permission",
    create: "roles_and_permission.create",
    read: "roles_and_permission.read",
    update: "roles_and_permission.update",
    delete: "roles_and_permission.delete",
    status: "roles_and_permission.status"
  }

  subscription_management = {
    subscription_management: "subscription_management",
    create: "subscription_management.create",
    read: "subscription_management.read",
    update: "subscription_management.update",
    delete: "subscription_management.delete",
    status: "subscription_management.status"
  }

  user_management = {
    user_management: "user_management",
    create: "user_management.create",
    read: "user_management.read",
    update: "user_management.update",
    delete: "user_management.delete",
    status: "user_management.status"
  }

  dashboard = {
    dashboard: "dashboard",
    create: "dashboard.create",
    read: "dashboard.read",
    update: "dashboard.update",
    delete: "dashboard.delete",
    status: "dashboard.status"
  }

  hr_mail_data = {
    hr_mail_data: "hr_mail_data",
    create: "hr_mail_data.create",
    read: "hr_mail_data.read",
    update: "hr_mail_data.update",
    delete: "hr_mail_data.delete",
    status: "hr_mail_data.status",
  }

  blogs = {
    blogs: "blogs",
    create: "blogs.create",
    read: "blogs.read",
    update: "blogs.update",
    delete: "blogs.delete",
    status: "blogs.status",
  }
}

export default new PermissionSlug();
